import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { CertificationsFragmentGql } from './DataQualityCertificationFragmentsGql';
import { TableFragmentGql } from './TableFragmentGql';

export const DatabaseTableQueryGql: DocumentNode = gql`
query DatabaseTableQuery($tableId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  databaseTables(filter: { id: $tableId }, permissionMode: FILTER_RESULTS) {
    ...TableFragment
    tags {
      name
    }
    ...CertificationsFragment
  }
}
${CertificationsFragmentGql}
${TableFragmentGql}
`;
